import React, { useState } from "react";
import { artistLeaderboardRoute, leaderboardRoute } from "../../../../services/leaderboardService";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import Indentification from "../../../../components/elements/Indentification";
import { initialsValue } from "../../../../helpers";

function LeaderboardCard({ user, type }) {
  const colors = user.rank === 1 ? "bg-yellow-200" : user.rank === 2 ? "bg-green-400" : user.rank === 3 ? "bg-indigo-200" : "bg-white";

  return (
    <div className={`flex items-center p-4 rounded-lg shadow-md ${colors}`}>
      <div className="w-16 h-16 flex-shrink-0">
        <Indentification
          initial={initialsValue(`${user?.firstName} ${user?.lastName}`)}
          image={user?.image?.url}
          alt={user?.firstName}
          fill={true}
          className={"!rounded-full"}
          size={"xl"}
        />
      </div>

      <div className="ml-4 flex-1">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">{`${user.firstName} ${user.lastName}`}</h2>
          <span className="text-[30px] font-bold"># {user.rank}</span>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-xl font-bold mt-1">{user.totalPoints}</p>
          {type === "artist" && <p className="text-sm text-gray-600 mt-1">❤️ {user.followersCount}</p>}
        </div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const [userLeaderboardData, setUserLeaderboardData] = useState([]);
  const [artistLeaderboardData, setArtistLeaderboardData] = useState([]);
  const [userFilters, setUserFilters] = useState({
    page: 1,
    limit: 5,
    date: new Date().toISOString().split("T")[0],
  });

  const [artistFilters, setArtistFilters] = useState({
    page: 1,
    limit: 5,
  });

  const { data: userData } = useQuery({
    queryKey: ["leaderboard", userFilters],
    queryFn: async () => {
      const res = await leaderboardRoute({
        ...userFilters,
      });
      if (res?.status !== 200) toast.warning(res?.message);
      setUserLeaderboardData((prev) => {
        const newData = res?.docs?.data.filter((item) => !prev.some((prevItem) => prevItem.uid === item.uid));
        return userFilters.page === 1 ? res?.docs?.data : [...prev, ...newData];
      });
      return res?.docs?.data || [];
    },
  });

  const { data: artistData } = useQuery({
    queryKey: ["artist-leaderboard", artistFilters],
    queryFn: async () => {
      const res = await artistLeaderboardRoute({
        ...artistFilters,
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      setArtistLeaderboardData((prev) => {
        const newData = res?.docs?.data.filter((item) => !prev.some((prevItem) => prevItem.uid === item.uid));
        return artistFilters.page === 1 ? res?.docs?.data : [...prev, ...newData];
      });

      return res?.docs?.data || [];
    },
  });
  return (
    <div>
      <i className="fas fa-tachometer-alt text-3xl text-pink-400"></i>
      <span className="mb-4 ml-2 font-bold text-3xl text-pink-500">Dashboard</span>
      <div className="p-6 bg-transparent min-h-screen">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[100px] items-start">
          <div className="bg-rose-50 p-4 rounded-md">
            <h2 className="text-xl font-bold mb-4">Leaderships</h2>
            <div className="grid grid-cols-1 gap-6">
              {userLeaderboardData?.map((user) => (
                <LeaderboardCard key={user.rank} user={user} type="user" />
              ))}
              {userData?.length >= userFilters.limit && (
                <div className="text-center mt-4">
                  <button
                    onClick={() => setUserFilters((prev) => ({ ...prev, page: prev.page + 1 }))}
                    className="px-4 py-2 bg-rose-200 hover:bg-rose-300 rounded-md font-semibold text-gray-700"
                  >
                    Load More...
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="bg-pink-100 p-4 rounded-md">
            <h2 className="text-xl font-bold mb-4">Fan</h2>
            <div className="grid grid-cols-1 gap-6">
              {artistLeaderboardData?.map((artist) => (
                <LeaderboardCard key={artist.rank} user={artist} type="artist" />
              ))}
              {artistData?.length >= artistFilters.limit && (
                <div className="text-center mt-4">
                  <button
                    onClick={() => setArtistFilters((prev) => ({ ...prev, page: prev.page + 1 }))}
                    className="px-4 py-2 bg-pink-200 hover:bg-pink-300 rounded-md font-semibold text-gray-700"
                  >
                    Load More...
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
